import { useCallback, useRef, useEffect } from 'react';

const isWindowUndefined = typeof window === 'undefined';

interface IUseWebOTPInputProps {
  onReceiveCode?: (code: string) => void;
  onOTPError?: (e: Error) => void;
}
function useWebOTPInput(input: IUseWebOTPInputProps = {}) {
  const { onReceiveCode, onOTPError } = input;
  const abortController = useRef<AbortController | null>(null);

  useEffect(() => {
    return () => {
      if (abortController.current) {
        abortController.current.abort();
      }
    };
  }, []);

  function abortListen() {
    if (abortController.current) {
      abortController.current.abort();
    }
  }

  const listenOTP = async () => {
    if (isWindowUndefined || !('OTPCredential' in window)) {
      return;
    }

    const ac = new AbortController();

    try {
      const oneTimePassword: any = await navigator.credentials.get({
        // @ts-ignore
        otp: { transport: ['sms'] },
        signal: ac.signal,
      });

      abortController.current = ac;

      if (onReceiveCode) {
        if (oneTimePassword?.code) {
          onReceiveCode(oneTimePassword.code as string);
        }
      }
    } catch (e) {
      if (onOTPError) {
        onOTPError(e as any);
      }
    }
  };

  return {
    listenOTP,
    abortListen: useCallback(abortListen, []),
  };
}

export default useWebOTPInput;
